<script setup>
import { truncateContent } from '@/js/core/utils/formatters';
import { useFocalPoint } from '@/js/core/composables/useFocalPoint';
import { trayRouteParams } from '@/js/core/utils/tray-route';
import { cancelTrayPrefetch, scheduleTrayPrefetch } from '@/js/core/utils/tray-prefetch';

const props = defineProps({
  tray: {
    type: Object,
    required: true,
  },
});

const { focalPointStyle } = useFocalPoint(() => props.tray.focal_point);
</script>

<template>
  <RouterLink
    class="tray-card"
    :to="{ name: 'tray-view', params: trayRouteParams(tray) }"
    @mouseenter="scheduleTrayPrefetch(tray.uuid)"
    @mouseleave="cancelTrayPrefetch()"
    @focus="scheduleTrayPrefetch(tray.uuid)"
    @blur="cancelTrayPrefetch()"
  >
    <h2 class="tray-card__title">{{ tray.title }}</h2>
    <div class="tray-card__thumbnail">
      <img
        v-if="tray.featured_media_url"
        :alt="tray.featured_media_alt || tray.title"
        :src="tray.featured_media_display?.url || tray.featured_media_url"
        :srcset="tray.featured_media_display?.srcset || undefined"
        :sizes="tray.featured_media_display?.srcset ? '(min-width: 769px) 50vw, 100vw' : undefined"
        :width="tray.featured_media_display?.width || undefined"
        :height="tray.featured_media_display?.height || undefined"
        class="tray-card__image"
        :style="focalPointStyle"
        loading="lazy"
        decoding="async"
        @contextmenu.prevent
      />
      <div v-else class="tray-card__placeholder" />
    </div>
    <p class="tray-card__content">
      {{ truncateContent(tray.content) }}
    </p>
  </RouterLink>
</template>
